import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cac17624"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "p-buttonset" };
import { onBeforeMount, ref, watch } from "vue";
import OneDeskTable from "@/components/organisms/OneDeskTable.vue";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import { serviceColumns } from "@/shared/utils/columns-definition/service";
import { FilterMatchMode } from "primevue/api";
import { deleteCatalogService, getCatalogServicesByCriteriaPaginated, } from "@/repositories/catalog-service.repository";
import AppConfigSideBar from "@/components/templates/Layout/AppConfigSideBar.vue";
import UpsertCatalogService from "@/components/templates/BackOffice/forms/catalog/UpsertCatalogService.vue";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdminCatalogServiceList',
    setup(__props) {
        const notify = useToastNotify();
        const columnsDefinition = ref(serviceColumns);
        const services = ref([]);
        const globalFilterFields = ref(["title"]);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const openAppConfig = ref(false);
        const selectedCatalogServiceId = ref(undefined);
        const loading = ref(false);
        const menuItems = ref([
            {
                //id: 'backoffice-service-add-button', // unique id for testing
                label: "Add Service",
                icon: "pi pi-tags",
                command: () => onAddServiceClick(),
            }
        ]);
        const search = ref("");
        const pageIndex = ref(1);
        const pageSize = ref(10);
        const totalRecords = ref(0);
        const totalPages = ref(0);
        watch([search, pageIndex, pageSize], () => {
            retrieveServices();
        });
        const onEditClick = (data) => {
            selectedCatalogServiceId.value = data.id;
            openAppConfig.value = true;
        };
        const onSearchChange = (searchText) => {
            search.value = searchText;
            pageIndex.value = 1;
        };
        const onDeleteClick = async (data) => {
            try {
                await deleteCatalogService(data.id);
                await retrieveServices();
            }
            catch (error) {
                notify('', `Error deleting service : ${error.message}`, "error");
            }
        };
        const onAddServiceClick = () => {
            selectedCatalogServiceId.value = undefined;
            openAppConfig.value = true;
        };
        onBeforeMount(async () => {
            await retrieveServices();
        });
        const onServiceUpdated = async () => {
            selectedCatalogServiceId.value = undefined;
            openAppConfig.value = false;
            await retrieveServices();
        };
        const retrieveServices = async () => {
            loading.value = true;
            const paginatedList = await getCatalogServicesByCriteriaPaginated(search.value, pageIndex.value, pageSize.value);
            services.value = paginatedList.items;
            totalPages.value = paginatedList.totalPages;
            totalRecords.value = paginatedList.totalCount;
            loading.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AppConfigSideBar, {
                    simple: "",
                    title: "Manage catalog cards",
                    active: selectedCatalogServiceId.value !== undefined,
                    modelValue: openAppConfig.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((openAppConfig).value = $event))
                }, {
                    default: _withCtx(() => [
                        _createVNode(UpsertCatalogService, {
                            "service-id": selectedCatalogServiceId.value,
                            onServiceUpdated: onServiceUpdated
                        }, null, 8, ["service-id"])
                    ]),
                    _: 1
                }, 8, ["active", "modelValue"]),
                _createVNode(OneDeskTable, {
                    title: "Services",
                    "columns-definition": columnsDefinition.value,
                    tableData: services.value,
                    class: "user_table",
                    hasPagination: true,
                    filters: filters.value,
                    globalFilterFields: globalFilterFields.value,
                    countLabel: { plural: 'services', singular: 'service' },
                    "has-menu": true,
                    "menu-items": menuItems.value,
                    "page-index": pageIndex.value,
                    "page-size": pageSize.value,
                    totalRecords: totalRecords.value,
                    lazy: true,
                    "on-row-click": ($event) => onEditClick($event),
                    onPageChange: _cache[1] || (_cache[1] = ($event) => (pageIndex.value = $event + 1)),
                    onSearchChange: _cache[2] || (_cache[2] = ($event) => (onSearchChange($event))),
                    loading: loading.value
                }, {
                    actions: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(OneDeskButton, {
                                "data-testid": "edit-button",
                                icon: "pi pi-pencil",
                                onClick: ($event) => (onEditClick(slotProps.item))
                            }, null, 8, ["onClick"]),
                            _createVNode(OneDeskButton, {
                                "data-testid": "delete-button",
                                icon: "pi pi-trash",
                                severity: "warning",
                                acceptCallback: () => onDeleteClick(slotProps.item),
                                "confirm-group": slotProps.item.id
                            }, null, 8, ["acceptCallback", "confirm-group"])
                        ])
                    ]),
                    _: 1
                }, 8, ["columns-definition", "tableData", "filters", "globalFilterFields", "menu-items", "page-index", "page-size", "totalRecords", "on-row-click", "loading"])
            ], 64));
        };
    }
});
